<template>
<div>
    <v-divider
      :key="betrieb.id" 
      v-if="index != 0"
    ></v-divider>
    <v-list-tile
      avatar
      ripple
      :href="betrieb.website"
      target="_blank"
      v-if="betrieb.premium && betrieb.website_ext && betrieb.website"
    >
    <v-list-tile-avatar 
      tile
      size="80"
      class="py-0 mt-0 mr-4"
      >
      <v-img
        v-if="betrieb.image_logo"
        :src="betrieb.image_logo"
        contain
        min-height="120px"
        max-height="160px"
      ></v-img>
        <v-img
        min-height="50px"
        max-height="80px"
        contain
        :src="Innungkombi[0].logo"
        v-else-if="Innungkombi[0].logo"
      ></v-img>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title class="title" style="line-height: 24px !important;">
          {{ betrieb.vollername }}
        <v-icon v-if="betrieb.verfuegbar" right color="green">check_circle</v-icon>
      </v-list-tile-title>
      <v-list-tile-sub-title class="subheading subheading grey--text text--darken-2">
      in {{ betrieb.stadtmitteil }}
        <span v-if="betrieb.entfernung">
          , {{ betrieb.entfernung }} km entfernt.
        </span>
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action class="py-1 hidden-xs-only">
      <v-btn
        flat
        light
        class="px-2 subheading"
        :large="betrieb.profilfarbe ? true : false"
        :href="betrieb.website"
        target="_blank"
        :color="betrieb.profilfarbe"
        v-if="betrieb.premium === 1 && betrieb.website_ext === 1"
      >
        <v-icon
          :color="betrieb.profilfarbe"
          left
          v-if="betrieb.premium_freigeschaltet === 1"
        >open_in_new</v-icon>
        Homepage Besuchen
      </v-btn>
       <v-btn
        flat
        light
        class="px-2 subheading"
        :large="betrieb.profilfarbe ? true : false"
        :to="{
          name: 'showCompany',
          params: { id: betrieb.slug }
        }"
        :color="betrieb.profilfarbe"
        v-if="betrieb.premium === 1 && betrieb.website_ext === 0"
      >
        <v-icon
          :color="betrieb.profilfarbe"
          left
          v-if="betrieb.premium_freigeschaltet === 1"
        >check_circle_outline</v-icon>
        Betriebsprofil
      </v-btn>
      <v-btn 
        ripple 
        flat 
        large
        class="px-2 mb-1 subheading" 
        v-if="betrieb.telefon && betrieb.premium === 0 && betrieb.website_ext === 0"
        v-on:click.stop
        v-bind:href="'tel:' + betrieb.telefon_link">
        <v-icon color="grey darken-1" left>phone</v-icon>
          {{ betrieb.telefon }}   
          <!-- <v-icon right color="primary">phone</v-icon>  -->
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>

  <v-list-tile
      avatar
      ripple
      :to="{ name: 'showCompany', params: { id: betrieb.slug } }"
      v-else
    >
    <v-list-tile-avatar 
      tile
      size="80"
      class="py-0 mt-0 mr-4"
      >
      <v-img
        v-if="betrieb.image_logo"
        :src="betrieb.image_logo"
        contain
        min-height="120px"
        max-height="160px"
      ></v-img>
        <v-img
        min-height="50px"
        max-height="80px"
        contain
        :src="Innungkombi[0].logo"
        v-else-if="Innungkombi[0].logo"
      ></v-img>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title class="title" style="line-height: 24px !important;">
        <a href="https://www.google.de" target="_blank"
          v-if="betrieb.website_ext">
          {{ betrieb.vollername }}
        </a> 
        <router-link
         :to="{ name: 'showCompany', params: { id: betrieb.slug } }"
         v-else>
          {{ betrieb.vollername }}
        </router-link>
        
        <v-icon v-if="betrieb.verfuegbar" right color="green">check_circle</v-icon>
      </v-list-tile-title>
      <v-list-tile-sub-title class="subheading subheading grey--text text--darken-2">
      in {{ betrieb.stadtmitteil }}
        <span v-if="betrieb.entfernung">
          , {{ betrieb.entfernung }} km entfernt.
        </span>
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action class="py-1 hidden-xs-only">
      <v-btn
        flat
        light
        class="px-2 subheading"
        :large="betrieb.profilfarbe ? true : false"
        :href="betrieb.website"
        target="_blank"
        :color="betrieb.profilfarbe"
        v-if="betrieb.premium === 1 && betrieb.website_ext === 1"
      >
        <v-icon
          :color="betrieb.profilfarbe"
          left
          v-if="betrieb.premium_freigeschaltet === 1"
        >open_in_new</v-icon>
        Homepage Besuchen
      </v-btn>
       <v-btn
        flat
        light
        class="px-2 subheading"
        :large="betrieb.profilfarbe ? true : false"
        :to="{
          name: 'showCompany',
          params: { id: betrieb.slug }
        }"
        :color="betrieb.profilfarbe"
        v-if="betrieb.premium === 1 && betrieb.website_ext === 0"
      >
        <v-icon
          :color="betrieb.profilfarbe"
          left
          v-if="betrieb.premium_freigeschaltet === 1"
        >check_circle_outline</v-icon>
        Betriebsprofil
      </v-btn>
      <v-btn 
        ripple 
        flat 
        large
        class="px-2 mb-1 subheading" 
        v-if="betrieb.telefon && betrieb.premium === 0 && betrieb.website_ext === 0"
        v-on:click.stop
        v-bind:href="'tel:' + betrieb.telefon_link">
        <v-icon color="grey darken-1" left>phone</v-icon>
          {{ betrieb.telefon }}   
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</div>
</template>

<script>
// import { mapGetters } from 'vuex'
import ListingSave from '~/components/ListingSave.vue'

export default {
  props: ['betrieb', 'index'],
  components: {
    ListingSave
  },

  data () {
    return {
      betriebcheckloading: true
    }
  },
  computed: {
    Innungkombi: function () {
      const superinnung = {}
      if (this.betrieb.innung) {
        if (this.betrieb.innungen) {
          const superinnnug = [].concat(
            this.betrieb.innung,
            this.betrieb.innungen
          )
          return superinnnug
        } else {
          return this.betrieb.innung
        }
      } else if (this.betrieb.innungen) {
        const superinnung = this.betrieb.innungen
        return superinnung
      }
      return superinnung
    }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style></style>
